import React from "react";
import { ProductListingView } from "..";

interface TopProductsAddToCartErrorMessageProps {
  errorMessage: string | undefined;
  itemNumber: string;
  productListingView: ProductListingView;
}

const TopProductsAddToCartErrorMessage = ({
  errorMessage,
  itemNumber,
  productListingView,
}: TopProductsAddToCartErrorMessageProps) => {
  const displayErrorMessage =
    productListingView === "topProductsCarousel" && errorMessage;

  return (
    <>
      {displayErrorMessage && (
        <p
          className="messages text-xs leading-none mt-0 mb-2 pt-0"
          role="alert"
          id={`error-message-${itemNumber}`}
        >
          {errorMessage}
        </p>
      )}
    </>
  );
};

export default TopProductsAddToCartErrorMessage;
